import { useCallback, useEffect, useState } from "react";
import {
  sanitizeSiteAbbreviation,
  suggestSiteAbbreviation,
} from "../utils/siteAbbreviationUtils";

export const QMS_DOCUMENT_ABBR_MAX_LENGTH = 10;
export const EISF_DOCUMENT_ABBR_MAX_LENGTH = 10;

const SUGGESTION_DELAY_MS = 300;

/**
 * Auto-suggest abbreviation from name (same behaviour as Site Management).
 * Stops suggesting once the user edits the abbreviation field manually.
 */
export function useDocumentMasterAbbreviationSuggest({
  nameValue,
  showModal,
  setAbbreviation,
  maxLength = QMS_DOCUMENT_ABBR_MAX_LENGTH,
}) {
  const [abbrTouched, setAbbrTouched] = useState(false);

  useEffect(() => {
    if (!showModal) {
      return undefined;
    }

    const trimmedName = String(nameValue || "").trim();

    if (!trimmedName) {
      if (!abbrTouched) {
        setAbbreviation("");
      }
      return undefined;
    }

    const timer = window.setTimeout(() => {
      if (!abbrTouched) {
        setAbbreviation(suggestSiteAbbreviation(nameValue, maxLength));
      }
    }, SUGGESTION_DELAY_MS);

    return () => window.clearTimeout(timer);
  }, [nameValue, showModal, abbrTouched, maxLength, setAbbreviation]);

  const resetSuggestState = useCallback((touched = false) => {
    setAbbrTouched(touched);
  }, []);

  const handleAbbreviationChange = useCallback(
    (value) => {
      setAbbrTouched(true);
      setAbbreviation(sanitizeSiteAbbreviation(value, maxLength));
    },
    [maxLength, setAbbreviation],
  );

  return {
    abbrTouched,
    resetSuggestState,
    handleAbbreviationChange,
  };
}
